import { render, staticRenderFns } from "./DocumentTable.vue?vue&type=template&id=1bf0211c&scoped=true"
import script from "./DocumentTable.vue?vue&type=script&lang=js"
export * from "./DocumentTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentTable.vue?vue&type=style&index=0&id=1bf0211c&prod&lang=scss"
import style1 from "./DocumentTable.vue?vue&type=style&index=1&id=1bf0211c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf0211c",
  null
  
)

export default component.exports